import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import AlertTriangle from '@/assets/icons/alertTriangleRounded';
import { Screen } from '@/components/ScreenComponent';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { Banner } from '@/feature/betslip-sbk/components/Banner';
import { SearchingAvatar } from '@/feature/results-arcade/components/PlayerMatchup/SearchingAvatar';
import { AVATAR_SIZE } from '@/feature/results-arcade/components/PlayerMatchup/SearchingAvatar';

export const ArcadeGameSearchLoading = () => {
    const { t } = useTranslation('arcade_game_details');
    return (
        <Screen edges={['top', 'bottom']}>
            <Box paddingHorizontal="s16" height="100%" position="relative">
                <Box position="absolute" right={16} left={16} top={8}>
                    <Banner
                        style={styles.banner}
                        borderWidth={1}
                        backgroundColor={ds.colorToken.background.neutral.subtler}
                        textColor={ds.colorToken.text.primary}
                        textVariant="bodySmall2"
                        leftIcon={<AlertTriangle />}
                        message={t('leave_app_warning')}
                    />
                </Box>

                <Box position="absolute" left={0} right={0} top="25%" alignItems="center">
                    <Text color="neutral300" variant="bodyMedium2">
                        {t('searching_for_opponent')}
                    </Text>
                </Box>

                <Box
                    position="absolute"
                    top="50%"
                    left={0}
                    right={0}
                    alignItems="center"
                    style={{ marginTop: -AVATAR_SIZE / 2 }}
                >
                    <SearchingAvatar />
                </Box>
            </Box>
        </Screen>
    );
};

const styles = StyleSheet.create({
    banner: {
        borderColor: ds.colorValue.border.subtle,
    },
});
